import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'

interface AccordionProps {
  title: React.ReactNode
  children: React.ReactNode
  additionalElements?: React.ReactNode
  defaultOpen?: boolean
  className?: string
  contentClassName?: string
}

export const Accordion = ({
  title,
  children,
  additionalElements,
  defaultOpen = true,
  className = '',
  contentClassName = '',
}: AccordionProps) => {
  const [isOpen, setOpen] = useState(defaultOpen)

  return (
    <div className={className}>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setOpen((v) => !v)
          }
        }}
        className="border-b-2 border-shade-blue w-full italic flex justify-between items-center cursor-pointer select-none"
      >
        <span className="flex items-center gap-1">
          {isOpen ? (
            <ChevronDownIcon className="w-4 h-4 shrink-0 not-italic" />
          ) : (
            <ChevronRightIcon className="w-4 h-4 shrink-0 not-italic" />
          )}
          {title}
        </span>
        {additionalElements}
      </div>
      {isOpen && <div className={contentClassName}>{children}</div>}
    </div>
  )
}
